import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.name";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@nerdwallet/react-typography';
import Stars from '@nerdwallet/react-star-rating';
import Icon from '@nerdwallet/react-icon';
import { Tracking } from '@nerdwallet/nw-client-lib';
import { BLUE, WHITE, GREY, LIGHTER_GREY, DARKEST_GREY } from '@nerdwallet/react-colors';
import Button from '@nerdwallet/react-button';
import { ImpressionClick, ProductImpression } from '@nerdwallet/nw-client-lib/tracking';
import formatNumberWithUnit from '../utils/num';
import ManagementFee from '../custom-components/management-fee';
import TradeFee from '../custom-components/trade-fee';
import OptionsFee from '../custom-components/options-broker-fee-caption';
var formOpen = Tracking.formOpen,
    formCancel = Tracking.formCancel;

var ProductRow =
/*#__PURE__*/
function (_Component) {
  _inherits(ProductRow, _Component);

  function ProductRow(props) {
    var _this;

    _classCallCheck(this, ProductRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductRow).call(this, props));
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      showDetails: false
    };
    return _this;
  }

  _createClass(ProductRow, [{
    key: "toggle",
    value: function toggle() {
      var trackingData = {
        formName: 'mobile-brokerage-table',
        fieldName: 'broker-row',
        fieldValue: this.props.name // eslint-disable-line

      };

      if (this.state.showDetails) {
        formCancel(trackingData);
      } else {
        formOpen(trackingData);
      }

      this.setState({
        showDetails: !this.state.showDetails
      });
    }
  }, {
    key: "renderDetails",
    value: function renderDetails() {
      if (!this.state.showDetails) {
        return null;
      }

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          promotionValue = _this$props.promotionValue,
          promotionLabel = _this$props.promotionLabel,
          website = _this$props.website,
          pros = _this$props.pros,
          rating = _this$props.rating,
          cons = _this$props.cons,
          bestFor = _this$props.bestFor,
          bottomLine = _this$props.bottomLine,
          review = _this$props.review;
      var reviewHref = "".concat(review, "?trk_location=product-table&trk_format=link");
      var ulStyle = {
        paddingLeft: 17,
        fontSize: 15,
        color: DARKEST_GREY,
        listStyle: 'initial'
      };
      return React.createElement("div", null, React.createElement("div", {
        colSpan: 4,
        style: {
          textAlign: 'center',
          padding: '20px 0px'
        }
      }, React.createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, React.createElement(ImpressionClick, {
        id: "mobile-brokerage-table-".concat(id),
        href: website,
        className: "btn-applynow",
        newWindow: true
      }, React.createElement(Button, {
        primary: true
      }, "Open an Account ", React.createElement(Icon, {
        font: "gizmo",
        className: "apply-now-icon",
        icon: "lock"
      })), React.createElement("div", {
        className: "button-caption",
        style: {
          color: GREY
        }
      }, React.createElement(Text, {
        small: true
      }, "on ", name, "'s website"))))), React.createElement("div", {
        colSpan: 4,
        style: {
          textAlign: 'center'
        }
      }, React.createElement("div", {
        style: {
          background: BLUE,
          color: WHITE,
          padding: '6px 0px'
        }
      }, "Current Offers"), React.createElement("div", {
        style: {
          padding: '14px 0px',
          background: '#e5f6f9',
          borderBottom: "1px solid ".concat(LIGHTER_GREY)
        }
      }, React.createElement("div", {
        style: {
          fontSize: 18,
          fontWeight: 300
        }
      }, promotionValue), React.createElement("div", {
        className: "annotation"
      }, React.createElement(Text, {
        small: true
      }, promotionLabel)))), React.createElement("div", {
        colSpan: 4,
        style: {
          lineHeight: '190%'
        }
      }, React.createElement("div", {
        style: {
          padding: '18px 25px',
          borderTop: "1px solid ".concat(LIGHTER_GREY),
          borderBottom: "1px solid ".concat(LIGHTER_GREY)
        }
      }, React.createElement("h4", {
        className: "h4"
      }, "The bottom line"), bottomLine, React.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, React.createElement("div", {
        style: {
          paddingTop: 12,
          marginBottom: -10
        }
      }, React.createElement(Stars, {
        rating: rating
      })), React.createElement("div", {
        style: {
          fontSize: 10,
          color: GREY
        }
      }, "NerdWallet rating"), React.createElement("a", {
        href: reviewHref
      }, "Read full review"))), React.createElement("div", {
        style: {
          borderBottom: "1px solid ".concat(LIGHTER_GREY),
          padding: '18px 30px'
        }
      }, React.createElement("h4", {
        className: "h4"
      }, "Pros"), React.createElement("ul", {
        style: ulStyle
      }, pros.map(function (pro, i) {
        return React.createElement("li", {
          key: "pro-".concat(i)
        }, pro);
      })), React.createElement("h4", {
        className: "h4",
        style: {
          paddingTop: 16
        }
      }, "Cons"), React.createElement("ul", {
        style: ulStyle
      }, cons.map(function (con, i) {
        return React.createElement("li", {
          key: "pro-".concat(i)
        }, con);
      }))), React.createElement("div", {
        style: {
          padding: '18px 30px'
        }
      }, React.createElement("h4", {
        className: "h4"
      }, name, " is best for"), React.createElement("ul", {
        style: ulStyle
      }, bestFor.map(function (best, i) {
        return React.createElement("li", {
          key: "best-for-".concat(i)
        }, best);
      })))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          logo = _this$props2.logo,
          tradeFee = _this$props2.tradeFee,
          managementFee = _this$props2.managementFee,
          accountMinimum = _this$props2.accountMinimum,
          rating = _this$props2.rating,
          website = _this$props2.website,
          slug = _this$props2.slug,
          showOptionsPricing = _this$props2.showOptionsPricing;
      var rowSectionStyle = {
        display: 'inline-block',
        flex: '3',
        padding: '20px 0px',
        fontSize: 18,
        fontWeight: 300,
        verticalAlign: 'middle'
      };
      var toggleIcon = this.state.showDetails ? 'up' : 'down';
      var tradeFees = React.createElement(TradeFee, {
        data: this.props
      });

      if (showOptionsPricing) {
        tradeFees = React.createElement("div", null, React.createElement(TradeFee, {
          data: this.props,
          noSuffix: true
        }), React.createElement(OptionsFee, {
          data: this.props
        }));
      }

      return React.createElement(ProductImpression, {
        id: "mobile-brokerage-table-".concat(id),
        productId: "".concat(id),
        productLocation: "table-row",
        linkType: "button",
        vertical: "Brokers",
        productSlug: slug
      }, React.createElement("div", {
        style: {
          borderRadius: 5,
          border: "1px solid ".concat(LIGHTER_GREY),
          background: WHITE,
          marginBottom: 12
        }
      }, React.createElement("div", {
        style: {
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
          alignItems: 'center'
        }
      }, React.createElement("div", {
        style: _objectSpread({}, rowSectionStyle, {
          paddingLeft: 10
        })
      }, React.createElement(ImpressionClick, {
        id: "mobile-brokerage-table-".concat(id),
        href: website,
        newWindow: true
      }, React.createElement("div", {
        style: {
          height: 35,
          width: '100%',
          backgroundImage: "url(".concat(logo, ")"),
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50%'
        }
      }), React.createElement("div", {
        style: {
          fontSize: 10
        }
      }, React.createElement(Stars, {
        nerdwallet: true,
        rating: rating
      })))), React.createElement("div", {
        style: rowSectionStyle,
        onClick: this.toggle
      }, React.createElement(ManagementFee, {
        data: this.props
      }), tradeFees), React.createElement("div", {
        style: rowSectionStyle,
        onClick: this.toggle
      }, "$", formatNumberWithUnit(accountMinimum)), React.createElement("a", {
        style: _objectSpread({}, rowSectionStyle, {
          flex: 1,
          paddingRight: 8
        }),
        onClick: this.toggle
      }, React.createElement(Icon, {
        font: "gizmo",
        icon: "navigate".concat(toggleIcon),
        style: {
          verticalAlign: 'middle',
          paddingRight: 4
        }
      }))), this.renderDetails(), React.createElement("div", {
        style: {
          height: 6
        }
      })));
    }
  }]);

  return ProductRow;
}(Component);

var MobileTable = function MobileTable(_ref) {
  var products = _ref.products,
      showOptionsPricing = _ref.showOptionsPricing;
  var rows = products.map(function (props, i) {
    return React.createElement(ProductRow, _extends({}, props, {
      key: "product-row-".concat(i),
      showOptionsPricing: showOptionsPricing
    }));
  });
  var headerStyle = {
    textAlign: 'center',
    fontWeight: '300',
    fontSize: 12,
    color: GREY,
    display: 'inline-block',
    width: '30%'
  };
  return React.createElement("div", null, React.createElement("div", {
    className: "product-table-wrapper",
    style: {
      paddingBottom: 0,
      paddingRight: 8,
      paddingLeft: 8,
      paddingTop: 16
    }
  }, React.createElement("div", null, React.createElement("div", {
    style: headerStyle
  }, "Broker"), React.createElement("div", {
    style: headerStyle
  }, "Commissions"), React.createElement("div", {
    style: headerStyle
  }, "Account Minimum"), React.createElement("div", {
    style: headerStyle
  })), rows));
};

MobileTable.displayName = 'MobileTable';
MobileTable.propTypes = {
  products: PropTypes.array,
  showOptionsPricing: PropTypes.bool
};
export default MobileTable;